import { render } from "./VueJsoneditor.vue?vue&type=template&id=2aaf8be4&scoped=true"
import script from "./VueJsoneditor.vue?vue&type=script&lang=js"
export * from "./VueJsoneditor.vue?vue&type=script&lang=js"

import "./VueJsoneditor.vue?vue&type=style&index=0&id=2aaf8be4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaf8be4"]])

export default __exports__